// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPreOrderSwitchDto
 */
export interface IPreOrderSwitchDto {
    /**
     * 
     * @type {number}
     * @memberof IPreOrderSwitchDto
     */
    instrument_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPreOrderSwitchDto
     */
    percentage: number;
}

/**
 * Check if a given object implements the IPreOrderSwitchDto interface.
 */
export function instanceOfIPreOrderSwitchDto(value: object): value is IPreOrderSwitchDto {
    if (!('instrument_id' in value) || value['instrument_id'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    return true;
}

export function IPreOrderSwitchDtoFromJSON(json: any): IPreOrderSwitchDto {
    return IPreOrderSwitchDtoFromJSONTyped(json, false);
}

export function IPreOrderSwitchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPreOrderSwitchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instrument_id': json['instrument_id'],
        'percentage': json['percentage'],
    };
}

export function IPreOrderSwitchDtoToJSON(json: any): IPreOrderSwitchDto {
    return IPreOrderSwitchDtoToJSONTyped(json, false);
}

export function IPreOrderSwitchDtoToJSONTyped(value?: IPreOrderSwitchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instrument_id': value['instrument_id'],
        'percentage': value['percentage'],
    };
}

